module.exports = __webpack_public_path__ + "images/icon-384.a04acdc7213ba7e7d4997f903b3486df.png";